export default "__VITE_ASSET__DYJlRwLR__"